/* global $:false */

import 'jquery-lazyload/jquery.lazyload.js'

import AbsenteeBidForm from 'src/public/absentee_bid_form.js'
import AccountIdentity from 'src/public/my_pages/account_identity.js'
import AlertBoxes from 'src/public/alert_boxes.js'
import Anniversary from 'src/public/anniversary.js'
import AnimatedFormInput from 'src/public/animated_form_input.js'
import AppNavigationBridge from 'src/public/app_navigation_bridge.js'
import BeneficialOwner from 'src/public/my_pages/beneficial_owner.js'
import BeneficialOwnerInserter from 'src/public/my_pages/beneficial_owner_inserter.js'
import BidHistory from 'src/public/live/bid_history.js'
import Bidder from 'src/public/live/bidder.js'
import CarouselSlideshow from 'src/public/carousel_slideshow.js'
import ClickRequiresLogin from 'src/public/click_requires_login.js'
import DetailsWithCachedState from 'src/public/details_with_cached_state.js'
import LotGalleryImage from 'src/public/lot_gallery_image.js'
import LotGalleryPinch from 'src/public/lot_gallery_pinch.js'
import LotGallerySwipeHint from 'src/public/lot_gallery_swipe_hint.js'
import LotGalleryThumbnail from 'src/public/lot_gallery_thumbnail.js'
import LotSocial from 'src/public/lot_social.js'
import ConnectionStateMonitor from 'src/shared/connection_state_monitor.js'
import ContactInfos from 'src/public/contact_infos.js'
import ContentBlockSlugs from 'src/public/content_block_slugs.js'
import CookieBanner from 'src/public/cookie_banner.js'
import CountdownJs from 'src/public/countdownjs.js'
import DirectUpload from 'src/public/direct_upload.js'
import EnvironmentBar from 'src/environment_bar.js'
import FAQ from 'src/public/faq.js'
import FacebookShare from 'src/public/facebook_share.js'
import Favorites from 'src/public/favorites.js'
import FilterList from 'src/public/filter_list.js'
import HtmlPush from 'src/shared/html_push.js'
import IeAspectRatioImage from 'src/public/ie_aspect_ratio_image.js'
import LiveBanner from 'src/public/live/live_banner.js'
import LoginDialog from 'src/public/login_dialog.js'
import LotIndex from 'src/public/lot_index.js'
import LotThumbnail from 'src/public/lot_thumbnails.js'
import LotsBannerBlock from 'src/public/lots_banner_block.js'
import MarketLotIndexLot from 'src/public/market_lot_index_lot.js'
import MarketLotShowBidExplanation from 'src/public/market_lot_show_bid_explanation.js'
import MarketLotShowSidebar from 'src/public/market_lot_show_sidebar.js'
import MegaMenu from 'src/public/mega_menu.js'
import PaymentPending from 'src/public/payment_pending.js'
import PopulateDataLayer from 'src/public/populate_data_layer.js'
import Popup from 'src/public/popup.js'
import ReadMore from 'src/public/read_more.js'
import RegistrationForm from 'src/public/registration_form.js'
import SearchObservers from 'src/public/search_observers.js'
import ShippingQuoteForm from 'src/public/shipping_quote_form.js'
import SidebarContentBlockSlugs from 'src/public/sidebar_content_block_slugs.js'
import SidemenuFolder from 'src/public/sidemenu_folder.js'
import Slidebar from 'src/public/slidebar.js'
import SystembolagetAgeForm from 'src/public/systembolaget_age_form.js'
import Toggler from 'src/public/toggler.js'
import TopbarContentBlockSlugs from 'src/public/topbar_content_block_slugs.js'
import Valuation from 'src/public/valuation.js'
import ValuationRequestCategory from 'src/public/my_pages/valuation_request_category.js'
import WatchingLiveChanges from 'src/public/live/watching_live_changes.js'
import PrintPage from 'src/public/my_pages/print_page.js'

export default class Site {
  static init () {
    AbsenteeBidForm.init()
    AccountIdentity.init()
    AlertBoxes.init()
    Anniversary.init()
    AnimatedFormInput.init()
    AppNavigationBridge.init()
    BeneficialOwner.init()
    BeneficialOwnerInserter.init()
    BidHistory.init()
    Bidder.init()
    CarouselSlideshow.init()
    ClickRequiresLogin.init()
    LotGalleryImage.init()
    LotGalleryPinch.init()
    LotGallerySwipeHint.init()
    LotGalleryThumbnail.init()
    LotSocial.init()
    ConnectionStateMonitor.init()
    ContactInfos.init()
    ContentBlockSlugs.init()
    CookieBanner.init()
    CountdownJs.init()
    DetailsWithCachedState.init()
    DirectUpload.init()
    EnvironmentBar.init()
    FAQ.init()
    FacebookShare.init()
    Favorites.init()
    FilterList.init()
    HtmlPush.init('html-push-' + window.gon.locale + '-')
    IeAspectRatioImage.init()
    LiveBanner.bannerOrFullPage()
    LoginDialog.init()
    LotIndex.init()
    LotThumbnail.init()
    LotsBannerBlock.init()
    MarketLotIndexLot.init()
    MarketLotShowBidExplanation.init()
    MarketLotShowSidebar.init()
    MegaMenu.init()
    PaymentPending.init()
    PopulateDataLayer.init()
    Popup.init()
    ReadMore.init()
    RegistrationForm.init()
    SearchObservers.init()
    ShippingQuoteForm.init()
    SidebarContentBlockSlugs.init()
    SidemenuFolder.init()
    Slidebar.init()
    SystembolagetAgeForm.init()
    Toggler.init()
    TopbarContentBlockSlugs.init()
    Valuation.init()
    ValuationRequestCategory.init()
    WatchingLiveChanges.init()
    PrintPage.init()

    $('img').lazyload({ threshold: 200, failure_limit: 15 })
  }
}
